export default __webpack_public_path__ + "static/media/img_blanket_grey_p.dc0d281f.jpg";